import { Component, inject, input } from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { Shared } from '../../index';
import { AppNotification } from '../../../proxy/models/app-notification';
import { ClickOutsideDirective } from '../../directives/click-outside.directive';
import { NotificationsPanelService, NotificationType } from '../../../core/services/notifications-panel.service';

@Component({
  selector: 'app-notifications-panel',
  imports: [
    ClickOutsideDirective,
    AsyncPipe,
    Shared,
  ],
  templateUrl: './notifications-panel-component.html',
  styleUrl: './notifications-panel-component.scss',
})
export class NotificationsPanelComponent {

  public notifications = input<AppNotification[] | null>();
  public notificationsPanelService = inject(NotificationsPanelService);

  public closePanel(): void {
    this.notificationsPanelService.onOpenNotifications(null);
  }

  public changeTab(tab: NotificationType): void {
    if (tab === this.notificationsPanelService.openNotifications.value) {
      return;
    }

    this.notificationsPanelService.onOpenNotifications(tab);
  }
}
